<template>
  <div class="tab-content-box clearfix">
    <div class="left-content">
      <code-box type="viewStyle" />
    </div>
    <div class="right-content">
      <div
        ref="rightContent"
        class="right-c-c scroll_bar_beautify_ff"
      >
        <!-- <a-switch
                :default-checked="itemData.ishidden"
                @change="onChange"
              /> -->
        <div class="define-sytle-c">
          {{ $t('message["1494"]') }}
          <a-tooltip
            placement="right"
            overlay-class-name="outside-config-tooltip"
          >
            <template slot="title">
              <span>{{ $t('message["1668"]') }}</span>
            </template>
            <i class="iconfont iconicon-test31" />
          </a-tooltip>
          <div class="define-switch-box">
            <a-button @click="getCustom">
              {{ $t('message["43"]') }}
            </a-button>
            <a-switch
              :default-checked="styleDatas.view_json[4].applyCustomCss"
              @change="changeCustomCss"
            />
          </div>
        </div>
        <template>
          <h2 class="right-c-tit">
            {{ $t('message["569"]') }}
            <span>{{ $t('message["334"]') }}px</span>
          </h2>
          <template v-if="styleDatas">
            <view-style-item
              v-for="(item, index) in viewJson"
              :key="index"
              :item-data="item"
            />
          </template>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import CodeBox from './CodeBox'
import { mapState } from 'vuex'
import ViewStyleItem from './editStyle/ViewStyleItem'
import { convertStyle, appendStyle, getH } from '@/store/universalForm/convert'
export default {
  components: {
    CodeBox,
    ViewStyleItem
  },
  data () {
    return {
      isShow: false,
      viewCss: ''
    }
  },
  computed: {
    ...mapState('universalForm/form', ['styleDatas', 'datasReady']),
    viewJson () {
      let { styleDatas = {} } = this
      let arr = []
      styleDatas.view_json.forEach(item => {
        if (Object.keys(item)[0] !== 'applyCustomCss') {
          arr.push(item)
        }
      })
      return arr
    }
  },
  watch: {
    styleDatas: {
      handler (val) {
        appendStyle(this.convertStyle(), 'view-css')
      },
      deep: true
    }
  },
  created () {
  },
  mounted () {
    this.$nextTick(() => {
      let $main = this.$refs.rightContent
      getH($main, 210)
    })
  },
  methods: {
    convertStyle () {
      const { viewJson } = this
      let str = ''
      str = convertStyle(viewJson)
      this.styleDatas.view_css = str
      return str
    },
    changeCustomCss (b) {
      if (b) {
        appendStyle(this.styleDatas.custom_css, 'custom-css')
      } else {
        let head = document.getElementsByTagName('head')[0]
        // document.querySelector('style[id="view-css"]').remove()
        const ele = document.getElementById('custom-css')
        if (ele) {
          head.removeChild(ele)
        }
      }
      this.styleDatas.view_json[4].applyCustomCss = b
    },
    getCustom () {
      this.$emit('getCustom')
    }
  }
}
</script>
<style lang="scss" scoped>
.right-c-c::v-deep {
  overflow-y: auto;
  width: 570px;
  padding-right: 24px;
  .right-c-tit {
    margin-bottom: 24px;
    font-weight: 600;
    span {
      margin-left: 16px;
      color: #f6a953;
      font-weight: normal;
    }
  }
  .define-sytle-c {
    height: 32px;
    line-height: 32px;
    position: relative;
    margin-bottom: 16px;
    .iconfont {
      color: #d8d8d8;
      font-size: 16px;
      margin-left: 10px;
      vertical-align: middle;
    }
    .define-switch-box {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}
</style>
<style lang="scss">
.outside-config-tooltip {
  .ant-tooltip-inner {
    color: $gray3;
  }
  .ant-tooltip-content:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    left: 1px;
    top: 50%;
    margin-top: -7px;
    border-width: 7px 8px 7px 0;
    border-color: transparent;
    border-right-color: #ebebeb;
    border-style: solid;
  }
  .ant-tooltip-arrow {
    left: 4px !important;
    z-index: 2;
    border-right-color: #fff !important;
  }
}
</style>
